import React from "react";
import { Link } from "react-router-dom";
import { timeSince } from "../util/utility";

interface IEpisodeProps {
    id: string;
    title: string;
    description?: string;
    createdAt?: string;
    state?: object;
}

export const Episode: React.FC<IEpisodeProps> = ({
    id,
    title,
    description,
    createdAt,
    state,
}) => (
    <Link to={{ pathname: `/episodes/${id}`, state }}>
        <div className="flex flex-col">
            <div className="flex flex-row m-5">
                <div
                    style={{ backgroundImage: `url(/images/podcast.jpeg)` }}
                    className="bg-cover bg-center w-20 h-20 rounded-lg"
                ></div>
                <div className="flex flex-col pl-5">
                    <h3 className="text-2xl">{title}</h3>
                    <span className="py-1 text-xs opacity-50 border-gray-400">
                        {timeSince(createdAt)}
                    </span>
                    <p className="py-1 text-xs">
                        {description}
                    </p>
                </div>
            </div>
        </div>
    </Link >
);
